// import assest from "@/json/assest";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
// import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
// import Image from "next/image";

// interface FilterModalProps {
//     open: boolean;
//     onClose?: () => void;
//     scroll?: "paper" | "body";
//     children: JSX.Element | JSX.Element[];
//     hideBackdrop?: boolean;
// }

const dialogContainer = {
    [`.MuiDialog-container`]: {
        alignItems: "flex-start",

        [`.MuiDialog-paper`]: {
            marginTop: "72px",
            borderRadius: "10px"
        }
    },
};

export default function NotificationFilterModal({
    open,
    onClose,
    scroll,
    children,
    hideBackdrop,
}) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Dialog
            hideBackdrop={hideBackdrop}
            fullScreen={fullScreen}
            open={open}
            onClose={onClose}
            scroll={scroll}
            aria-labelledby="responsive-dialog-title"
            PaperProps={{
                sx: {
                    width: "100%",
                    maxWidth: "787px",

                    [`& .MuiDialogContent-root`]: {
                        padding: "0 11px"
                    },
                },
            }}
            sx={dialogContainer}
        >
            {/* <IconButton onClick={onClose} autoFocus>
                <img src={assest.crossGray} width={9} height={9} alt="icon" />
            </IconButton> */}
            <DialogContent>{children}</DialogContent>
        </Dialog>
    );
}

